// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ServerEventsActions {
  export class Connect {
    static readonly type = '[SERVER EVENTS] Connect';
  }

  export class Disconnect {
    static readonly type = '[SERVER EVENTS] Disconnect';
  }

  export class CheckConnection {
    static readonly type = '[SERVER EVENTS] Check Connection';
  }

  export class SubscribeToOrganizationEvents {
    static readonly type = '[SERVER EVENTS] Subscribe To Organization Events';
  }

  export class UnsubscribeFromOrganizationEvents {
    static readonly type = '[SERVER EVENTS] Unsubscribe From Organization Events';
    constructor(public organizationId: string) {}
  }

  export class SubscribeToActivityEvents {
    static readonly type = '[SERVER EVENTS] Subscribe To Activity Events';
    constructor(public activityId: string) {}
  }

  export class UnsubscribeFromActivityEvents {
    static readonly type = '[SERVER EVENTS] Unsubscribe From Activity Events';
    constructor(public activityId: string) {}
  }
}
